import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { API_LINK } from '../../apiLink/apiLink';

const LibraryOverdue = ({ onNavigate }) => {
    const [overdueBooks, setOverdueBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchOverdueBooks();
    }, []);

    const fetchOverdueBooks = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_LINK}/api/library/overdue`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const result = await response.json();

            if (result.success) {
                setOverdueBooks(result.data.overdueBooks || []);
            } else {
                setError(result.message || 'Failed to fetch overdue books');
            }
        } catch (err) {
            console.error('Error fetching overdue books:', err);
            setError('An error occurred while fetching overdue books');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
    };

    // Note: Send Reminder functionality requires an email/SMS backend service
    const handleSendReminder = (memberId) => {
        alert(`Reminder sending feature for ${memberId} is not yet implemented.`);
    };

    return (
        <Layout role="librarian" onNavigate={onNavigate} activePage="library-overdue" pageTitle="Overdue Books">
            <div style={{ padding: '20px' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '2rem' }}>⚠️ Overdue Books</h2>

                {error && (
                    <div style={{ backgroundColor: '#ffeef0', color: '#e53935', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #ffccd5' }}>
                        <strong>❌ Error:</strong> {error}
                    </div>
                )}

                <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                    <div style={{ overflowX: 'auto' }}>
                        {loading ? (
                            <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>Loading overdue books...</div>
                        ) : (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#ffebee', color: '#c62828', textAlign: 'left' }}>
                                        <th style={{ padding: '15px' }}>Book Title</th>
                                        <th style={{ padding: '15px' }}>Member Name</th>
                                        <th style={{ padding: '15px' }}>Member ID</th>
                                        <th style={{ padding: '15px' }}>Due Date</th>
                                        <th style={{ padding: '15px' }}>Days Overdue</th>
                                        <th style={{ padding: '15px' }}>Est. Fine</th>
                                        <th style={{ padding: '15px' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {overdueBooks.length > 0 ? (
                                        overdueBooks.map((item, index) => (
                                            <tr key={item.id} style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '15px', fontWeight: '500' }}>{item.bookTitle}</td>
                                                <td style={{ padding: '15px' }}>{item.memberName}</td>
                                                <td style={{ padding: '15px' }}>{item.memberId}</td>
                                                <td style={{ padding: '15px' }}>{formatDate(item.dueDate)}</td>
                                                <td style={{ padding: '15px', color: '#d32f2f', fontWeight: 'bold' }}>{item.daysOverdue} Days</td>
                                                <td style={{ padding: '15px' }}>₹{item.estimatedFine}</td>
                                                <td style={{ padding: '15px' }}>
                                                    <button
                                                        onClick={() => handleSendReminder(item.memberId)}
                                                        style={{
                                                            backgroundColor: '#d32f2f',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '6px 12px',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer',
                                                            fontSize: '12px'
                                                        }}
                                                    >
                                                        Send Reminder
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" style={{ padding: '2rem', textAlign: 'center', color: '#666', fontWeight: '500' }}>
                                                🎉 No overdue books at the moment!
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default LibraryOverdue;
